import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { MultiSearchSource } from "@/shop/types/multiSearch";

import * as MultiSearchActions from "../actions";
import type { IMultiSearchResultState } from "../types";

type MultiSearchResultActionType =
  | ActionType<typeof MultiSearchActions.fetchStart>
  | ActionType<typeof MultiSearchActions.fetchSuccess>
  | ActionType<typeof MultiSearchActions.fetchFail>
  | ActionType<typeof MultiSearchActions.clearResults>;

export function createMultiSearchInitialState(source: MultiSearchSource): IMultiSearchResultState {
  return {
    source,
    data: null!,
    isFetching: false,
    hasError: false
  };
}

export function createMultiSearchResultReducer(initialState: IMultiSearchResultState) {
  return function multiSearchResultReducer(state: IMultiSearchResultState = initialState, action: MultiSearchResultActionType): IMultiSearchResultState {
    if (action.meta && action.meta.collection === state.source) {
      switch (action.type) {
        case getType(MultiSearchActions.fetchStart):
          return { ...state, isFetching: true };
        case getType(MultiSearchActions.fetchFail):
          return { ...state, isFetching: false, hasError: true };
        case getType(MultiSearchActions.fetchSuccess):
          return { ...state, isFetching: false, data: action.payload };
        case getType(MultiSearchActions.clearResults):
          return { ...createMultiSearchInitialState(action.meta.collection) };
        default:
          return state;
      }
    } else {
      return state;
    }
  };
}
